import { palette2, RcClasses, setOpacity, } from '../../../../../foundation';
import { RcDefaultTextFieldWidth } from '../../../TextField/styles';
export var textColor = palette2('neutral', 'f06');
export var primaryColor = palette2('interactive', 'b02');
export var primaryHoverColor = setOpacity(primaryColor, '16');
export var disabledColor = palette2('disabled', 'f02');
export var RcDatePickerClasses = RcClasses([
    'popover',
    'popoverPaper',
    // calendar
    'calendarSlider',
    'footer',
    'progress',
    // header
    'header',
    'leftArrow',
    'rightArrow',
    'select',
], 'RcDatePicker');
export var RcDatePickerSizes = {
    small: {
        width: RcDefaultTextFieldWidth,
        height: '296px',
    },
    medium: {
        width: '272px',
        height: '308px',
    },
};
export var RcDatePickerIconWidths = {
    small: '18px',
    medium: '28px',
};
export var focusDayElement = function (doc) {
    if (doc === void 0) { doc = document; }
    var elm = doc.querySelector('[data-picker-focused]');
    elm === null || elm === void 0 ? void 0 : elm.focus();
};
export var isSameYearAndMonth = function (_a, utils) {
    var source = _a.source, comparing = _a.comparing;
    if (!source || !comparing) {
        return false;
    }
    var thisMonth = utils.getMonth(source);
    var thisYear = utils.getYear(source);
    var comparingMonth = utils.getMonth(comparing);
    var comparingYear = utils.getYear(comparing);
    return thisMonth === comparingMonth && thisYear === comparingYear;
};
export var onTransitionEnd = function (event, doc) {
    if (doc === void 0) { doc = document; }
    var activeElm = doc.activeElement;
    if (event.target.dataset['transitionTag'] &&
        // * check is not focus on other thing, like click next month
        activeElm.dataset['pickerAction'] !== 'true') {
        focusDayElement();
    }
};
export var invalidateDateInRange = function (day, _a, utils) {
    var _b = _a.dateRange, min = _b.min, max = _b.max, disableFuture = _a.disableFuture, disablePast = _a.disablePast, now = _a.now;
    if (disableFuture && utils.isAfterDay(day, now)) {
        return now;
    }
    if (disablePast && utils.isBeforeDay(day, now)) {
        return now;
    }
    if (min && utils.isBeforeDay(day, utils.date(min))) {
        return min;
    }
    if (max && utils.isAfterDay(day, utils.date(max))) {
        return max;
    }
    return false;
};
